import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const IconHeader = (props) => (
    <div>
        <div className="customHeaderLabel">{props.displayName}</div>
        {props.icon && <FontAwesomeIcon icon={props.icon} />}
    </div>
);